import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppExportBase64 {
  constructor() {}

  public downloadPDF(pdf: string, title: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement('a');
    const fileName = this.generateTitle(title) + '.pdf';

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  public downloadExcel(excel: string, title: string) {
    const linkSource = `data:application/xlsx;base64,${excel}`;
    const downloadLink = document.createElement('a');
    const fileName = this.generateTitle(title) + '.xlsx';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  public guiaPdf(pdf: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;

    const pdfWindow = window.open();

    if (pdfWindow) {
      pdfWindow.document.write(
        `<iframe width='100%' height='100%' src='${linkSource}'></iframe>`
      );
    }
  }

  private generateTitle(nome: string): string {
    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const dia = String(hoje.getDate()).padStart(2, '0');
    return `${ano}${mes}${dia} - ${nome}`;
  }
}
